import axios from '../axios';
import Vue from 'vue';
import * as constants from '../constants';

function addChildren(obj, node) {
  for (let elm of obj) {
    if (elm.id === node.parent_id) {
      if (typeof (elm.children) === 'undefined') {
        elm.children = [];
      }
      elm.children.push(node);
    } else if (elm.children) {
      addChildren(elm.children, node);
    }
  }
};

function appendNode(node, data, state) {
  if (node.parent_id === 0) { return; }
  const parent = state.data.find(n => n.id === node.parent_id);
  if (typeof (data.find(d => d.id === parent.id)) === 'undefined') {
    data.push({ ...parent });
  }
  appendNode(parent, data, state);
};

function deleteChildren(state, id) {
  const index = state.data.findIndex(n => n.id === id);
  if (index === -1) {
    return;
  }
  state.data.splice(index, 1);
  let child = state.data.find(n => n.parent_id === id);
  if (child) {
    deleteChildren(state, child.id);
  }
}

export default {
  namespaced: true,

  state: {
    data: [],
    selectedItem: null,
    filter: '',
    dialog: null
  },

  actions: {
    LOAD({ commit }, { filter }) {
      let params = {};
      if (filter) {
        for (let key in filter) {
          if (filter.hasOwnProperty(key) && filter[key] !== null) {
            params[key] = filter[key];
          }
        }
        if (filter.sortBy) {
          params.order_by = `${filter.sortBy}:${filter.descending ? 'DESC' : 'ASC'}`;
        }

        delete params.sortBy;
        delete params.descending;
        delete params.totalItems;
      }
      return new Promise((resolve, reject) => {
        axios.get(`${constants.SERVER_URL}/api/actions`, { params: params })
          .then(response => response.data)
          .then(response => {
            commit('ACTIONS', response.data);
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    },

    EDIT({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.put(`${constants.SERVER_URL}/api/actions/${data.id}`, data)
          .then(response => {
            commit('EDIT', response.data.data);
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    },

    ADD({ commit }, data) {
      return new Promise((resolve, reject) => {
        delete data.id;
        axios.post(`${constants.SERVER_URL}/api/actions/`, data)
          .then(response => {
            commit('ADD', response.data.data);
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    },

    DELETE({ commit }, id) {
      commit('DELETE', id);
      return new Promise((resolve, reject) => {
        axios.delete(`${constants.SERVER_URL}/api/actions/${id}`)
          .then(response => {
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    }
  },

  mutations: {

    ACTIONS(state, payload) {
      state.data = payload;
    },

    EDIT(state, payload) {
      for (const [index, value] of state.data.entries()) {
        if (value.id === payload.id) {
          Vue.set(state.data, index, payload);
          state.selectedItem.name = payload.name;
        }
      }
    },

    ADD(state, payload) {
      state.data.unshift({ ...payload });
    },

    DELETE(state, id) {
      state.selectedItem = null;
      deleteChildren(state, id);
    },

    SELECT(state, payload) {
      state.selectedItem = payload;
    },

    FILTER(state, payload) {
      state.filter = payload;
      if (payload) {
        state.selectedItem = null;
      }
    },

    DIALOG(state, payload) {
      state.dialog = payload;
    }
  },

  getters: {
    tree: (state) => {
      const obj = [];
      let data = state.data.slice(0);
      if (state.filter) {
        data = data.filter(node => {
          return node.name.toUpperCase().includes(state.filter.toUpperCase());
        });
        data.map(node => {
          appendNode(node, data, state);
        });
      }

      data.sort((a, b) => {
        if (a.parent_id - b.parent_id === 0) {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        } else if (a.parent_id - b.parent_id < 0) {
          return -1;
        } else if (a.parent_id - b.parent_id > 0) {
          return 1;
        }
      }).map(node => {
        if (node.parent_id === 0) {
          obj.push({ ...node, children: [] });
        } else {
          addChildren(obj, { ...node });
        }
      });
      return obj;
    },

    action: (state, getters) => id => {
      const action = state.data.find(f => f.id === id);
      if (action) {
        action.path = '';
        const data = [];
        appendNode(action, data, state);
        data.reverse();
        data.forEach(element => {
          action.path = `${action.path}${element.name}  > `;
        });
        action.path = `${action.path}${action.name}`;
        return action;
      }
      return {
        id: -1,
        path: '- nedefinit -'
      };
    }
  }
};
